<template>
	<div :class="['o-width-limiter o-width-limiter--main', className]">
		<div class="o-grid t-margin--1-top">
			<div
				v-for="(puff, index) in puffs"
				:key="index"
				class="o-grid__column c-puff-block__group"
				data-size="md:12 lg:4"
			>
				<div
					:class="[
						'c-puff-block',
						puff.className,
						puff.color === 'orange' && 'bg-orange',
						puff.color === 'pink' && 'bg-pink',
						puff.color === 'blue' && 'bg-blue',
						puff.color === 'green' && 'bg-green',
						puff.url && 'has-link'
					]"
				>
					<div class="c-puff-block--imagearea">
						<img
							:src="puff.src"
							:alt="puff.alt"
							:title="puff.text"
						/>
					</div>
					<div class="c-puff-block--textarea">
						<a v-if="puff.url !== ''" :href="puff.url">
							{{ puff.text }}
						</a>

						<p
							v-else
							:class="[
								puff.textAlignment === 'left' && 'text-left',
								puff.textAlignment === 'center' &&
									'text-center',
								puff.textAlignment === 'right' && 'text-right'
							]"
						>
							{{ puff.text }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VPuffBlock",
	props: {
		puffs: {
			type: Array,
			default: () => []
		}
	}
};
</script>
